import { LocationControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author rajkumar rathod
 */
export const useLocationAvatar = () =>
  useMutationWithLoading(
    async (params: {
      userid: string;
      newavatar?: string;
      xTENANTID?: string;
    }) =>
      new LocationControllerApi(getConfigObject()).changeAvatar3(
        params.userid,
        {
          newAvatar: params?.newavatar,
        },
        params.xTENANTID
      )
  );
